module.exports = __webpack_public_path__ + "img/success.2758fc17.png";